export default "__VITE_ASSET__1QBFp1VG__"